import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container } from 'reactstrap';

import Page from '../../components/Layout/Page/Page';
import RoundedButton from '../../components/Buttons/RoundedButton/RoundedButton';
import TrackWave from '../../components/Tracks/TrackWave/TrackWave';
import TrackRow from '../../components/Tracks/TrackRow/TrackRow';
import Loader from '../../components/Common/Loader';
import PlayButton from '../../components/Buttons/PlayButton/PlayButton';

import { ReactComponent as RewardsIcon } from '../../assets/images/reward.svg';

import { loadAllTracks, loadTrackComments, updateTrackPublic } from '../../helpers/api/tracks.api';

import '../Tracks/Tracks.scss';

const AdminTracks = props => {
    const [loading, setLoading] = useState(true);
    const [tracks, setTracks] = useState([]);

    const [playing, setPlaying] = useState(false);

    const [track, setTrack] = useState(null);
    const [trackComments, setTrackComments] = useState([]);

    useEffect(() => {
        setLoading(true);
        loadAllTracks()
            .then((result) => {
                if (result.success) {
                    setTracks(result.tracks);
                    setTrack(result.tracks[0]);
                } else {
                    console.log(result.message);
                    setTracks([]);
                    setTrack(null);
                }
                setLoading(false);
            })
            .catch((error) => {
                setTracks([]);
                setTrack(null);
                setLoading(false);
                console.log(error);
            });
    }, []);

    useEffect(() => {
        if (tracks && tracks[0] && !track)
            setTrack(tracks[0]);
    }, [tracks]);

    useEffect(() => {
        if (track) loadComments();
    }, [track]);

	function loadComments() {
		loadTrackComments(track._id)
        .then((result) => {
            if (result.success) {
                setTrackComments(result.comments);
            } else {
                console.log(result.message);
                setTrackComments([]);
            }
        })
        .catch((error) => {
            setTrackComments([]);
            console.log(error);
        });
	}

    return <Page className="tracks">
        <Container fluid className="h-100 d-flex flex-column">
            <Row className="h-50 pb-3">
                <Col className="h-100 d-flex flex-column justify-content-between">
                    {loading ?
                        <Loader />
                        : track ?
                            <>
                                <Row>
                                    <Col sm="6" className="d-flex align-items-center">
                                        <div className="d-flex flex-column mr-5">
                                            <h6><i>Tutti i brani</i></h6>
                                            <h4 className="mb-0">{track.title}</h4>
                                            <h6>{track.author.name}</h6>
                                        </div>
										<PlayButton playing={playing} onClick={() => setPlaying(!playing)} />
                                        
                                    </Col>
                                    <Col sm="6" className="d-flex align-items-center justify-content-end">
                                        
                                            <div className="d-flex justify-content-end">
                                                <p className="track-points">
                                                    {track.points || 0}
                                                    {' punti'}
                                                </p>
                                                <p className="track-rewards">
                                                    <RewardsIcon />
                                                    {track.rewards ? track.rewards.length : 0}
                                                    {' Rewards'}
                                                </p>
                                            </div>
                                            <RoundedButton color="primary" className="px-3 ml-4" onClick={() => props.history.push('/users/' + track.author._id)}>VISUALIZZA Profilo</RoundedButton>
                                    </Col>
                                </Row>
                                <div className="wave-wrapper">
                                    <TrackWave audioFile={track.file.url} comments={trackComments} playing={playing} />
                                </div>
                            </> : null}
                </Col>
            </Row>

            <Row className="h-50 pt-3">
                <Col className="h-100">
                    <ul className="tracks-list h-100">
                        {tracks.map(t => <TrackRow key={t._id} track={t} onPlayClick={() => setTrack(t)} />)}
                    </ul>
                </Col>
            </Row>
        </Container>
        </Page>;
}

const mapStatetoProps = (state) => {
    return { user: state.Auth.user };
};

export default connect(mapStatetoProps, {})(AdminTracks);